<h2 mat-dialog-title>Audit Log Details</h2>
<div mat-dialog-content>
	<div class="row">
		<div class="col" [innerHtml]="html"></div>
	</div>
	<div mat-dialog-actions class='px-0'>
		<button mat-stroked-button mat-dialog-close class="" >Close</button>
	</div>
</div>
